(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["price"] && !Shopify.designMode) return;
  try {
    // Keeps the struck-through offer price in step with the selected variant
  document.addEventListener('variant:update', (event) => {
    const html = event.detail && event.detail.data && event.detail.data.html;
    if (!html || !html.querySelector) return;
    document.querySelectorAll('product-price [data-offer-block]').forEach((current) => {
      const fresh = html.querySelector('[data-offer-block="' + current.dataset.offerBlock + '"]');
      if (fresh) current.innerHTML = fresh.innerHTML;
    });
  });
  } catch(e) { console.error(e); }
})();

})();
